"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("@widget-editor/shared");

var _styleConstants = require("@widget-editor/shared/lib/styles/style-constants");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledFooter = _styledComponents["default"].footer.withConfig({
  displayName: "component__StyledFooter",
  componentId: "xd8mvj-0"
})(["", " width:100%;height:", ";align-self:flex-end;display:flex;align-items:center;justify-content:space-between;"], function (props) {
  return props.disabled && (0, _styledComponents.css)(["display:none;"]);
}, _styleConstants.FOOTER_HEIGHT);

var Footer = function Footer(_ref) {
  var enableSave = _ref.enableSave,
      onSave = _ref.onSave;
  return _react["default"].createElement(StyledFooter, {
    disabled: !enableSave
  }, enableSave && _react["default"].createElement(_shared.Button, {
    role: "button",
    type: "button",
    btnType: "cta",
    onClick: onSave
  }, "Save widget"));
};

var _default = Footer;
exports["default"] = _default;